









































import Vue, { PropType } from "vue";
import { mapGetters } from "vuex";
import ContentComponentEditor from "./ContentComponentEditor.vue";
import pxCard from "@/dex-shared/components/px-card.vue";
import pxButton from "@/dex-shared/components/px-button.vue";
import CloseCircleOutlineIcon from "vue-material-design-icons/CloseCircleOutline.vue";
import ArrowUpDownBoldOutlineIcon from "vue-material-design-icons/ArrowUpDownBoldOutline.vue";
import draggable from "vuedraggable";
import TextModel from "@/dex-shared/models/TextModel";
import ImageModel from "@/dex-shared/models/ImageModel";
import VideoModel from "@/dex-shared/models/VideoModel";
import ContentModel from '@/dex-shared/models/ContentModel';

export default Vue.extend({
  components: {
    ContentComponentEditor,
    pxCard,
    pxButton,
    CloseCircleOutlineIcon,
    ArrowUpDownBoldOutlineIcon,
    draggable
  },
  props: {
    questionId: {
      type: Number,
      required: false,
      default: null
    },
    solutionId: {
      type: Number,
      required: false,
      default: null
    },
    articleId: {
      type: Number,
      required: false,
      default: null
    },
    assertionId: {
      type: Number,
      required: false,
      default: null
    }
  },
  computed: {
    mutableContent: {
      get() {
        return this.contents
      },
      set(sortedContents: Array<ContentModel>) {
        sortedContents.forEach(
          (content:ContentModel, position: number) => {
            this.$store.commit("UPDATE_ENTITY_PROP", {
              id: content.id,
              entity: "contents",
              propToUpdate: "position",
              value: position
            })
          }
        )
      }
    },
    ...mapGetters({
      questionById: "questionById",
      articleById: "articleById",
      solutionById: "solutionById",
      assertionById: "assertionById"
    }),
    contents() {
      if (this.questionId) {
        return this.questionById(this.questionId).contents()
      } else if (this.articleId) {
        return this.articleById(this.articleId).contents()
      } else if (this.solutionId) {
        return this.solutionById(this.solutionId).contents()
      } else if (this.assertionId) {
        return this.assertionById(this.assertionId).contents()
      }
    },
    trustedContent() {
      return !!(this.questionId || this.articleId || this.assertionId || this.solutionId);
    }
  },
  methods: {
    async insertText() {
      this.$store.dispatch("CREATE_AND_ASSOCIATE_CONTENT", {
        aggregatorId: this,
        type: ContentModel.__types.text
      });
    },
    async insertImage() {
      this.$store.dispatch("CREATE_AND_ASSOCIATE_CONTENT", {
        aggregatorId: this,
        type: ContentModel.__types.image
      });
    },
    async insertVideo() {
      this.$store.dispatch("CREATE_AND_ASSOCIATE_CONTENT", {
        aggregatorId: this,
        type: ContentModel.__types.video
      });
    },
    removeComponent(contentId: number) {
      if (confirm("Esse conteúdo será permanentemente deletado mesmo antes da conclusão da edição. Tem certeza que deseja remover esse bloco de conteúdo?")) {
        this.$store.dispatch("DELETE_CONTENT", contentId);
      }
    },
    moveComponent(from: number, to: number) {
      // change content position
    }
  }
});
